<template>
  <div class="c-admin-manufacturer">
    <div
      class="c-admin-manufacturer__item o-grid o-grid--gutter-normal o-grid--no-overflow o-grid--align-items-center"
      :class="{ 'c-admin-manufacturer__item--active': active }"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <div
            class="c-admin-manufacturer__item-text"
            :title="manufacturer.name"
          >
            {{ manufacturer.name }}
          </div>
        </div>
        <div class="o-grid__item o-grid__item--3">
          {{
            manufacturer.isSelectable
              ? translationsCustom.selectableForEndUsers
              : translationsCustom.notSelectableForEndUsers
          }}
        </div>
        <div
          class="o-grid__item o-grid__item--grow-0 o-grid__item--align-right"
        >
          <div
            class="c-admin-manufacturer__actions o-grid o-grid--gutter-tiny o-grid--align-items-center"
          >
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--grow-0">
                <button
                  type="button"
                  class="o-button o-button--transparent o-button--clean"
                  :title="translationsManufacturersTable.addModel || ''"
                  @click.stop="showModelCreate(manufacturer)"
                >
                  <svg
                    class="o-svg-icon o-button__icon o-button__icon--action  o-button__icon--shadow o-button__icon--round"
                    viewBox="0 0 64 64"
                    type="image/svg+xml"
                  >
                    <use
                      xlink:href="spritemap.svg#sprite-plus"
                      x="0"
                      y="0"
                    ></use>
                  </svg>
                  <span>{{
                    translationsManufacturersTable.addModel || ""
                  }}</span>
                </button>
              </div>
              <div
                class="c-admin-manufacturer__separator o-grid__item o-grid__item--grow-0"
              ></div>
              <div class="o-grid__item o-grid__item--grow-0">
                <button
                  @click.stop="showManufacturerEdit(manufacturer)"
                  class="o-button o-button--action o-button--round o-button--light o-button--shadow"
                >
                  <svg
                    class="o-svg-icon o-button__icon"
                    viewBox="0 0 64 64"
                    type="image/svg+xml"
                  >
                    <use
                      xlink:href="spritemap.svg#sprite-edit"
                      x="0"
                      y="0"
                    ></use>
                  </svg>
                </button>
              </div>
              <div class="o-grid__item o-grid__item--grow-0">
                <button
                  :disabled="manufacturer.manufacturerIsInUse"
                  :title="
                    manufacturer.manufacturerIsInUse
                      ? 'Manufacturer is in use and cannot be deleted'
                      : 'Delete manufacturer'
                  "
                  @click.stop="showManufacturerDelete(manufacturer)"
                  class="o-button o-button--action o-button--round o-button--light o-button--shadow"
                >
                  <svg
                    class="o-svg-icon o-button__icon"
                    viewBox="0 0 64 64"
                    type="image/svg+xml"
                  >
                    <use
                      xlink:href="spritemap.svg#sprite-delete"
                      x="0"
                      y="0"
                    ></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="active" class="o-grid o-grid--no-overflow">
      <div class="o-grid__group">
        <div
          class="o-grid__item o-grid__item--12"
          v-for="model in manufacturer.models"
          :key="model.id"
        >
          <CallCenterADMINmodel :model="model"></CallCenterADMINmodel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CallCenterADMINmodel from "@/components/Admin/admin-model.vue";
export default {
  components: {
    CallCenterADMINmodel
  },
  props: {
    manufacturer: { type: Object, required: true },
    active: { type: Boolean, required: true }
  },
  computed: {
    ...mapState("manufacturers", {
      translationsManufacturersTable: "manufacturersTable",
      translationsCustom: "custom"
    }),
    ...mapState("translations", {
      translationsManufacturersTable: "manufacturersTable",
      translationsCustom: "custom"
    })
  },
  methods: {
    ...mapMutations("manufacturers", [
      "setEditManufacturer",
      "setDeleteManufacturer",
      "setEditModel"
    ]),
    showManufacturerEdit(manufacturer) {
      this.setEditManufacturer(manufacturer);
    },
    showManufacturerDelete(manufacturer) {
      this.setDeleteManufacturer(manufacturer);
    },
    showModelCreate(manufacturer) {
      this.setEditModel(manufacturer);
    }
  }
};
</script>

<style lang="scss">
.c-admin-manufacturer {
  $root: &;
  &__item {
    background-color: $s-cp-neutral-white;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 3px;
    padding: 0 10px;
    &:hover {
      cursor: pointer;
      background-color: $s-cp-neutral-800;
    }

    &--active {
      background-color: $s-cp-sup-light;
      cursor: default;

      #{$root}__item-text:before {
        transform: translate(0, -50%) rotate(90deg);
      }
    }
  }
  &__item-text {
    @include setStyles("14", $s-typography-sizes);
    font-weight: 700;
    color: $s-cp-sup-blue;
    position: relative;
    padding-left: 30px;
    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 10px;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;

      border-left: 8px solid $s-cp-sup-blue;
      transform: translate(0, -50%);
      transition: transform ease-in-out 0.25s;
    }
  }
  &__separator:before {
    content: "";
    display: block;
    margin: 0 5px;
    min-height: 46px;
    height: 100%;
    width: 1px;
    background: $s-cp-neutral-600;
  }
}
</style>
